'use client';
import React, { FC, useState } from 'react';
import {
  TypeInputSelect,
  TypeKeyValuePair,
  TypeKeyValuePairFields,
} from '@/core/generated-types';
import styles from './Select.module.scss';

interface SelectProps extends TypeInputSelect {
  name: string;
  selectedEntry?: number | string;
  labelClassName?: string;
  onChangeEvent?: (
    option: React.ChangeEvent<HTMLSelectElement>,
  ) =>
    | TypeKeyValuePairFields
    | React.ChangeEvent<{ value: string | number }>
    | void;
}

const Select: FC<SelectProps> = ({
  name = '',
  fields,
  onChangeEvent = null,
  selectedEntry,
  labelClassName,
}) => {
  const { label, dropdownOptions } = fields;
  const [selected, setSelected] = useState(selectedEntry);

  const handleOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelected(event.currentTarget.value);
    if (onChangeEvent) {
      onChangeEvent(event); // send back the whole event for flexibility
    }
  };

  return (
    <div>
      <p className={labelClassName}>{label}</p>
      <select
        name={name}
        value={selected}
        onChange={(event) => handleOnChange(event)}
        className={`select w-full rounded-sm border border-grey-midtone text-lg ${styles.select}`}
      >
        {dropdownOptions.map((option) => {
          const { fields, sys } = option as TypeKeyValuePair;
          const { value, title } = fields as TypeKeyValuePairFields;

          return (
            <option key={sys.id} value={value as string | number}>
              {title}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default Select;
